import { updateFeed } from '@/mocks/home';

function SectionHeading({
  eyebrow,
  title,
  desc,
}: {
  eyebrow: string;
  title: string;
  desc: string;
}) {
  return (
    <div>
      <span className="font-label text-xs tracking-[0.2em] text-primary-600">{eyebrow}</span>
      <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
      <p className="mt-3 max-w-md text-sm leading-7 text-foreground-600">{desc}</p>
    </div>
  );
}

export default function UpdateTimeline() {
  return (
    <section id="updates" className="w-full bg-background-100">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="UPDATES / 最新地址"
            title="最新地址与线路更新快讯"
            desc="入口、域名与安装包的每一次调整都会在这里留痕，按时间倒序排列，方便你对照当前可用状态。"
          />
          <div className="mt-6 flex items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-4 py-3">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-radar-line text-base" />
            </span>
            <p className="text-xs leading-6 text-foreground-600">
              入口状态每 10 分钟检测一次，异常线路会自动从列表移除。
            </p>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ol className="relative border-l border-background-300/70 pl-6 md:pl-8">
            {updateFeed.map((item) => (
              <li key={item.id} className="relative pb-7 last:pb-0">
                <span className="absolute -left-[31px] top-1 flex h-3 w-3 items-center justify-center md:-left-[39px]">
                  <span className="h-2.5 w-2.5 rounded-full border-2 border-background-50 bg-primary-500" />
                </span>
                <div className="flex flex-wrap items-center gap-2.5">
                  <span className="font-label text-xs font-medium text-foreground-500">{item.date}</span>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] text-secondary-900">
                    {item.tag}
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm leading-7 text-foreground-600">{item.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}